import config from '../../helpers/config'
import loadFonts from '../../helpers/fonts/fontLoader'

import actionTypes from '../actions/actionTypes'
import { AnyAction } from 'redux'
import mixpanel from '../../helpers/mixpanel'

const searchFonts = (action: AnyAction) => {
	if (action.data.main && action.data.main.fonts) {
		loadFonts(action.data.main.fonts)
	}
}

const configLoaded = (action: AnyAction) => {
	config.setConfig(action.config)
	mixpanel.init(action.config.mixpanel.clientId)
}

const generalMessageMiddleware = (_store: any) => {
	return (next: (action: unknown) => unknown) => (rawAction: unknown) => {
		const action = rawAction as AnyAction
		switch (action.type) {
			case actionTypes.APP_CONFIG_LOADED:
				configLoaded(action)
				break
			case actionTypes.APP_SKIN_LOADED:
				searchFonts(action)
				break
		}
		next(action)
	}
}

export default generalMessageMiddleware
